import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form/immutable';
import {
  Button, Card, CardBody, CardTitle,
} from 'reactstrap';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { Loading } from '../../../../../loadbar/Loading';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import {
  searchTsunamis as searchTsunamisAc,
  sortTsunamis as sortTsunamisAc,
  getTsunamis as getTsunamisAc,
  getReference as getReferenceAc,
  searchReferences as searchReferencesAc,
  createDeposit as createDepositAc,
  getDeposit as getDepositAc,
  updateDeposit as updateDepositAc,
  clearDeposit as clearDepositAc,
  getGeologicalAge as getGeologicalAgeAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  getBodiesOfWater as getBodiesOfWaterAc,
  getCountries as getCountriesAc,
  getEvents as getEventsAc,
  getLocationNames as getLocationNamesAc,
  getPublications as getPublicationsAc,
  sortReferences as sortReferencesAc,
  toggleReferenceColumns as toggleReferenceColumnsAc,
  toggleTsunamiColumns as toggleTsunamiColumnsAc,
} from '../../../../../../redux/tsunamis/deposits/edit/depositEditActions';
import { depositEditModel, createInitialForm, formToJson } from './depositEditModel';
import { LabeledCheckbox } from '../../../../../form/LabeledCheckbox';
import { SingularAssociatedReferenceControl } from '../../../../../form/SingularAssociatedReferenceControl';
import { AssociatedTsunamisControl } from '../../../../../form/AssociatedTsunamisControl';
import { EditForm } from '../../../../../form/EditForm';

/*
import { withUser } from '../../../../../auth/withUser';
import { isDataManager } from '../../../../../../role/roleUtils';
*/


const model = depositEditModel.get('name');
const initialValues = depositEditModel.get('initialValues');

class DepositEditPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Deposit Edit';
    const {
      match: { params: { id } },
      getDeposit,
      getTsunamis,
      getBodiesOfWater,
      getCountries,
      getEvents,
      getGeologicalAge,
      getLocationNames,
      getPublications,
      getReference,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getDeposit({ id });
      getTsunamis({ id });
      getReference({ id });
    }
    getLocationNames();
    getPublications();
    getEvents();
    getBodiesOfWater();
    getGeologicalAge();
    getCountries();
    this.setState(state);
  }

  componentDidUpdate() {
    const {
      fetched, initializeForm, deposit,
    } = this.props;
    const { initialized } = this.state;
    if (!initialized) {
      if (fetched) {
        const form = createInitialForm(deposit);
        initializeForm(form);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearDeposit,
    } = this.props;
    clearDeposit();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, deposit,
    } = this.props;
    resetForm();
    // There seems to be a bug in react-redux-form. This needs to be called to set the original references.
    change('', createInitialForm(deposit));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { isAdd, initialized } = this.state;
    const {
      pristine,
      updating,
      reference,
      referenceSearching,
      referenceSearchResults,
      searchReferences,
      sortReferences,
      refSort,
      tsunamis,
      searchTsunamis,
      sortTsunamis,
      tsunamiSearching,
      tsunamiSearchResults,
      tsuSort,
      events,
      geologicAges,
      countries,
      locationNames,
      publications,
      bodyOfWater,
      match: { params: { id } },
      history,
      deposit,
      createDeposit,
      updateDeposit,
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      toggleTsunamiColumns,
      tsuVisibleColumns,
      toggleReferenceColumns,
      refVisibleColumns,
    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }

    return (
      <div className="haz-results-container haz-page-container">

        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">{isAdd ? 'Add Deposit' : `Edit Deposit: ${id}`}</CardTitle>

            <EditForm
              model={model}
              hazardName="Deposit"
              saving={updating}
              create={createDeposit}
              update={updateDeposit}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={deposit}
            >

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Date and Location</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".yearBegin" label="Year Begin" readOnly={updating} helpModalId="year" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".yearEnd" label="Year End" readOnly={updating} helpModalId="year" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".latitude" label="Latitude" readOnly={updating} helpModalId="latitude" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".longitude" label="Longitude" readOnly={updating} helpModalId="longitude" />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={locationNames.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="locationName" label="Location" readOnly={updating} filterable addable />
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="country" label="Country" readOnly={updating} filterable addable />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={bodyOfWater.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="bodyOfWater" label="Body of Water" readOnly={updating} filterable addable />
                    <LabeledSelect childOptions={geologicAges.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="geologicAgeId" label="Geologic Age" readOnly={updating} filterable addable />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={publications.toJS()} formGroupClassName={['col-lg-12']} parentModel={model} fieldId="publicationType" label="Publication" readOnly={updating} filterable addable />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".ageDescription" label="Age Description" readOnly={updating} />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".description" label="Description" readOnly={updating} />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={events.toJS()} formGroupClassName={['col-lg-12']} parentModel={model} fieldId="event" label="Event" readOnly={updating} filterable addable />
                  </div>


                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-lg-12']} model=".environment" label="Environment" readOnly={updating} />
                  </div>

                </CardBody>
              </Card>


              <AssociatedTsunamisControl
                model={model}
                searchTsunamis={config => searchTsunamis({ ...config, history })}
                tsunamiSearching={tsunamiSearching}
                tsunamiSearchResults={tsunamiSearchResults}
                formTsunamiIds={tsunamis}
                sortData={sortTsunamis}
                sort={tsuSort}
                initialTsunamis={tsunamis}
                visibleColumns={tsuVisibleColumns}
                toggleColumns={toggleTsunamiColumns}
              />

              <SingularAssociatedReferenceControl
                model={model}
                reference={reference}
                searchReferences={config => searchReferences({ ...config, history })}
                referenceSearching={referenceSearching}
                referenceSearchResults={referenceSearchResults}
                sort={refSort}
                sortData={sortReferences}
                visibleColumns={refVisibleColumns}
                toggleColumns={toggleReferenceColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Visibility</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".publish" label="Publish" />
                  </div>
                </CardBody>
              </Card>

              <div>
                <Button disabled={updating || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={updating || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={updating} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>

      </div>
    );
  }
}

DepositEditPageUnwrapped.propTypes = {
  getTsunamis: PropTypes.func.isRequired,
  searchReferences: PropTypes.func.isRequired,
  clearDeposit: PropTypes.func.isRequired,
  createDeposit: PropTypes.func.isRequired,
  getDeposit: PropTypes.func.isRequired,
  searchTsunamis: PropTypes.func.isRequired,
  updateDeposit: PropTypes.func.isRequired,
  deposit: ImmutablePropTypes.map.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  fetched: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  change: PropTypes.func.isRequired,
  sortTsunamis: PropTypes.func.isRequired,
  tsuSort: ImmutablePropTypes.list.isRequired,
  sortReferences: PropTypes.func.isRequired,
  refSort: ImmutablePropTypes.list.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
  getReference: PropTypes.func.isRequired,
  getGeologicalAge: PropTypes.func.isRequired,
  getBodiesOfWater: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getEvents: PropTypes.func.isRequired,
  events: ImmutablePropTypes.list.isRequired,
  getLocationNames: PropTypes.func.isRequired,
  getPublications: PropTypes.func.isRequired,
  tsunamis: ImmutablePropTypes.list.isRequired,
  tsunamiSearchResults: ImmutablePropTypes.list.isRequired,
  tsunamiSearching: PropTypes.bool.isRequired,
  reference: ImmutablePropTypes.map.isRequired,
  referenceSearchResults: ImmutablePropTypes.list.isRequired,
  referenceSearching: PropTypes.bool.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  locationNames: ImmutablePropTypes.list.isRequired,
  geologicAges: ImmutablePropTypes.list.isRequired,
  bodyOfWater: ImmutablePropTypes.list.isRequired,
  publications: ImmutablePropTypes.list.isRequired,
  toggleTsunamiColumns: PropTypes.func.isRequired,
  tsuVisibleColumns: ImmutablePropTypes.list.isRequired,
  toggleReferenceColumns: PropTypes.func.isRequired,
  refVisibleColumns: ImmutablePropTypes.list.isRequired,

};

const defaultMap = Map();

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['depositEditPage', 'fetchedCountries']),
    state.getIn(['depositEditPage', 'fetchedLocationNames']),
    state.getIn(['depositEditPage', 'fetchedGeologicAges']),
    state.getIn(['depositEditPage', 'fetchedPublications']),
    state.getIn(['depositEditPage', 'fetchedBodyOfWater']),
    state.getIn(['depositEditPage', 'fetchedEvents']),
  ];
  if (!isAdd) {
    fetchedCheck.push(
      state.getIn(['depositEditPage', 'fetched']),
      state.getIn(['depositEditPage', 'fetchedTsunamis']),
      state.getIn(['depositEditPage', 'fetchedReference']),
    );
  }

  const references = state.getIn(['depositEditPage', 'reference']);

  return {
    fetched: fetchedCheck.every(v => v),
    deposit: state.getIn(['depositEditPage', 'deposit']),
    tsunamis: state.getIn(['depositEditPage', 'tsunamis']),
    reference: references.size ? references.get(0) : defaultMap,
    pristine: state.get('forms')[model].$form.pristine,
    updating: state.getIn(['depositEditPage', 'updating']),
    referenceSearching: state.getIn(['depositEditPage', 'referenceSearching']),
    referenceSearchResults: state.getIn(['depositEditPage', 'referenceSearchResults']),
    tsunamiSearching: state.getIn(['depositEditPage', 'tsunamiSearching']),
    tsunamiSearchResults: state.getIn(['depositEditPage', 'tsunamiSearchResults']),
    countries: state.getIn(['depositEditPage', 'countries']),
    geologicAges: state.getIn(['depositEditPage', 'geologicAges']),
    bodyOfWater: state.getIn(['depositEditPage', 'bodyOfWater']),
    publications: state.getIn(['depositEditPage', 'publications']),
    locationNames: state.getIn(['depositEditPage', 'locationNames']),
    events: state.getIn(['depositEditPage', 'events']),
    tsuSort: state.getIn(['depositEditPage', 'tsuSort']),
    refSort: state.getIn(['depositEditPage', 'refSort']),
    formData: state.getIn(['depositEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['depositEditPage', 'editConfirmationOpen']),
    tsuVisibleColumns: state.getIn(['depositEditPage', 'tsuVisibleColumns']),
    refVisibleColumns: state.getIn(['depositEditPage', 'refVisibleColumns']),
  };
};


const mapDispatchToProps = dispatch => bindActionCreators({
  searchTsunamis: searchTsunamisAc,
  sortTsunamis: sortTsunamisAc,
  getTsunamis: getTsunamisAc,
  getReference: getReferenceAc,
  searchReferences: searchReferencesAc,
  createDeposit: createDepositAc,
  getDeposit: getDepositAc,
  updateDeposit: updateDepositAc,
  clearDeposit: clearDepositAc,
  getGeologicalAge: getGeologicalAgeAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  getBodiesOfWater: getBodiesOfWaterAc,
  getCountries: getCountriesAc,
  getEvents: getEventsAc,
  getLocationNames: getLocationNamesAc,
  getPublications: getPublicationsAc,
  sortReferences: sortReferencesAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  initializeForm: initial => actions.load(model, initial),
  setPristine: () => actions.setPristine(model),
  toggleTsunamiColumns: toggleTsunamiColumnsAc,
  toggleReferenceColumns: toggleReferenceColumnsAc,

}, dispatch);

export const DepositEditPage = connect(mapStateToProps, mapDispatchToProps)(DepositEditPageUnwrapped);
